<template>
  <div>
    <div class="quota-inquiry-table-container tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="index" label="序号" align="left" fixed="left">
          <template v-slot="{ row, $index }">
            {{ (row.itemIndex = $index + 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="creditQuotaAmt" label="信用额度(元)" align="right" header-align="left" />
        <el-table-column prop="usedQuotaAmt" label="已用额度(元)" align="right" header-align="left" />
        <el-table-column prop="availableQuotaAmt" label="可用额度(元)" align="right" header-align="left" />
        <el-table-column prop="enbaledFlag" label="是否启用" align="left" />
      </el-table>
    </div>
    <div class="remark-text-container-style">
      <p>备注：</p>
      <ul class="remark-list">
        <li>1、已用额度：指贵公司在锐捷网络的信用额度中，已经使用的部分。</li>
        <li>2、可用额度：指贵公司在锐捷网络的信用额度中，还剩下多少额度可以继续使用。</li>
        <li>3、“信用额度、已用额度、可用额度”的货币单位均为人民币元。</li>
        <li>4、“已用额度”不包括下单流程未结束的赊销订单信息，提示贵公司关注流程中的赊销订单，以免超额。</li>
      </ul>
    </div>
  </div>
</template>

<script type="es6">
import { getCreditMoneyDataList } from '@/API/creditAxios';

export default {
  data () {
    return {
      loading: false,
      tableData: [
      ]
    };
  },
  methods: {
    getTableDataList () {
      this.loading = true;
      getCreditMoneyDataList().then((res) => {
        let { data, status } = res.data;
        if (status === '200') {
          console.log(`范湖的数据`, data);
          this.tableData = data || [];
        }
        this.loading = false;
        console.log(res);
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    this.getTableDataList();
  }
};
</script>

<style scoped lang="scss">
.quota-inquiry-table-container{
  margin: 20px 0;
}
.remark-text-container-style {
  margin-top: 20px;
  .remark-list {
    list-style-type: none;
    padding-left: 0;
    li {
      font-family: 'Your Font', sans-serif;
      line-height: 2;
      text-align: left;
    }
  }
}
</style>
